<template>
  <div id="app">
    <SidebarMenu v-if="isLogedIn"/>
    <router-view/>
  </div>
</template>

<script>
    import store from './store';
    import SidebarMenu from '@/components/SidebarMenu'
    export default {
        data() {
          return {
            isLogedIn: false
          }
        },
        components: {
          SidebarMenu,
        },
        watch: {
          '$route' (to, from) {
            var toRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
            var fromRequiresAuth = from.matched.some(record => record.meta.requiresAuth)
            if(toRequiresAuth && !fromRequiresAuth){
              this.isLogedIn = true
              location.reload()
              console.log(localStorage.getItem('accessToken'))
            }
            if(!toRequiresAuth && fromRequiresAuth){
              this.isLogedIn = false
              location.reload()
            }
            if(toRequiresAuth && fromRequiresAuth){
              this.isLogedIn = true
            }
          }
        },
        mounted () {
          store.dispatch('fetchAccessToken');
          if (!store.state.accessToken) {
            this.isLogedIn = false
          } else {
            this.isLogedIn = true
          }
        },
    }
</script>

<style lang="scss">
body {
  background: #edf1f7 !important;
}
.login-container {
    background-image: url('/assets/img/background-bni.jpg');
    background-repeat: repeat-x;
    background-size: contain;
    background-position: bottom;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 100vh;
    align-content: center;
    justify-content: center;
}
</style>
